import React from "react";
import { FOOTER_VSL } from "../../../data";
import { openConsentSettings } from "../../../lib/tracking";

export default function VslFooter() {
  return (
    <footer className="pt-14 pb-12 px-4" style={{ borderTop: "1px solid rgba(255,255,255,0.07)" }}>
      <div className="mx-auto max-w-[1000px] lg:max-w-[1440px] lg:px-8">
        <div className="flex justify-center mb-12">
          <img
            src="/img/logo-hts-3d.webp"
            alt="HighTicketSales.it" data-testid="footer-logo"
            loading="lazy"
            style={{ width: "100%", maxWidth: 340, height: "auto" }}
          />
        </div>

        <div className="grid gap-8 sm:grid-cols-3">
          {FOOTER_VSL.cols.map((col) => (
            <div key={col.title}>
              <div className="v-label" style={{ letterSpacing: "0.2em" }}>{col.title}</div>
              <ul className="mt-4 space-y-2" style={{ listStyle: "none", padding: 0, margin: 0 }}>
                {col.links.map((l) => (
                  <li key={l}>
                    <a href="#" className="v-sans" style={{ color: "#B4B1BA", fontSize: "0.92rem", textDecoration: "none" }}>{l}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <hr className="v-rule my-9" />

        <p className="v-sans text-center mx-auto" style={{ maxWidth: "70ch", fontSize: "0.82rem", color: "#7C7A83", lineHeight: 1.6 }}>
          {FOOTER_VSL.disclaimer}
        </p>
        <p className="v-sans text-center mt-4" style={{ fontSize: "0.85rem", color: "#98959F" }}>{FOOTER_VSL.copyright}</p>
        <div className="mt-3 flex justify-center">
          <button type="button" onClick={openConsentSettings} data-testid="footer-cookie-settings" className="v-sans underline underline-offset-4" style={{ fontSize: "0.82rem", color: "#98959F", background: "none", border: 0 }}>
            Preferenze cookie
          </button>
        </div>
      </div>
    </footer>
  );
}
